"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplicationState = void 0;
const react_query_1 = require("@tanstack/react-query");
const dareDropClient_1 = require("root/src/client/v2/common/clients/dareDropClient");
const queryClient_1 = require("root/src/client/v2/common/clients/queryClient");
const users_constants_1 = require("root/src/shared/users/users.constants");
const queryKey = ['useApplicationState'];
const useApplicationState = () => {
    const queryClient = (0, react_query_1.useQueryClient)(queryClient_1.globalQueryClient);
    const query = (0, react_query_1.useQuery)({
        queryKey,
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            return (0, dareDropClient_1.dareDropClient)({
                endpointId: users_constants_1.usersEndpointIds.GET_APPLICATION_STATE,
            });
        }),
    }, queryClient);
    const invalidateApplicationState = () => __awaiter(void 0, void 0, void 0, function* () {
        yield queryClient.resetQueries({ queryKey });
    });
    return {
        applicationState: query.data,
        invalidateApplicationState,
    };
};
exports.useApplicationState = useApplicationState;
